if (!customElements.get('ej-mix-cookie-sort')) {
  customElements.define('ej-mix-cookie-sort', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.grid = this.closest('edition-product-mix')?.querySelector('#main-collection-product-grid');
      if (!this.select || !this.form || !this.status || !this.grid) return;
      this.appliedSort = this.select.value;
      this.onChange = () => this.sort();
      this.onSubmit = event => { event.preventDefault(); this.sort(); };
      this.select.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      const initial = new URL(window.location.href).searchParams.get('sort_by');
      if (this.dataset.sourceUrl && ['best-selling','price-ascending','price-descending'].includes(initial)) {
        this.select.value = initial; void this.sort();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.grid?.removeAttribute('aria-busy');
      this.select?.removeEventListener('change', this.onChange);
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    async sort() {
      const requestedSort = this.select.value;
      if (!['created-descending', 'best-selling', 'price-ascending', 'price-descending'].includes(requestedSort)) return;
      this.controller?.abort();
      const controller = this.controller = new AbortController();
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', requestedSort);
      url.searchParams.delete('page');
      const requestUrl = new URL(url);
      if (this.dataset.sourceUrl) {
        requestUrl.pathname = new URL(this.dataset.sourceUrl, window.location.origin).pathname;
        requestUrl.searchParams.set('view', 'vic-cookiebites');
      }
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.status.textContent = 'Sorterer cookies…';
      this.grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(requestUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('Sorting request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        const sortedGrid = html.getElementById('main-collection-product-grid');
        if (!sortedGrid) throw new Error('Missing cookie grid');
        const orderedIds = Array.from(sortedGrid.querySelectorAll('[data-mix-card]'), card => card.id);
        const cards = Array.from(this.grid.querySelectorAll('[data-mix-card]'));
        const existing = new Map(cards.map(card => [card.id, card.parentElement]));
        if (existing.size !== cards.length || orderedIds.length !== existing.size || new Set(orderedIds).size !== existing.size
          || orderedIds.some(id => !existing.has(id) || existing.get(id).parentElement !== this.grid)) {
          throw new Error('Cookie list changed');
        }
        // Keep the original card nodes, popup content and the builder's selected items.
        orderedIds.forEach(id => this.grid.appendChild(existing.get(id)));
        this.appliedSort = requestedSort;
        history.replaceState(history.state, '', url);
        this.status.textContent = 'Cookies er sorteret.';
      } catch (error) {
        if (controller.signal.aborted) return;
        this.select.value = this.appliedSort;
        this.status.textContent = 'Sorteringen kunne ikke hentes. Prøv igen. Dine valgte cookies er bevaret.';
      } finally {
        if (this.controller === controller) this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
